import { useCallback, useState } from 'react';

import authRequest from '../utils/fetch';

const URL = '/gateway/api/adminhub/um/user/my/permissions';

export const useJiraAdminPermissions = () => {
	const [error, setError] = useState<string | null>(null);
	const [loading, setLoading] = useState<boolean>(false);
	const [permissions, setPermissions] = useState<string[]>([]);

	const getJiraAdminPermissions = useCallback(async (cloudId: string) => {
		setLoading(true);
		setError(null);
		const resourceAri = `ari:cloud:jira::site/${cloudId}`;

		try {
			const response = await fetch(
				authRequest(`${URL}?resourceAri=${resourceAri}`, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
					},
				}),
			);

			if (!response.ok) {
				throw new Error(`Error: ${response.statusText}`);
			}

			const data = (await response.json()) as Record<string, string[]>;

			if (data[resourceAri]) {
				setPermissions(data[resourceAri]);
			} else {
				setError('An error has occurred');
			}
		} catch (e) {
			setError('An error has occurred');
		}

		setLoading(false);
	}, []);

	return {
		getJiraAdminPermissions,
		permissions,
		loading,
		error,
	};
};
